import PhotoSizeSelectActualOutlinedIcon from '@mui/icons-material/PhotoSizeSelectActualOutlined';
import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import { useState } from 'react';

type PublisherLogoProps = {
  name?: string | null;
  height?: number;
};

const commonContainerStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
};

export const PublisherLogo = ({ name, height }: PublisherLogoProps) => {
  const [isError, setIsError] = useState(false);

  if (!name || isError) {
    // Render a placeholder icon when no name is provided or if there is an error loading the image
    return (
      <Box sx={commonContainerStyles}>
        <PhotoSizeSelectActualOutlinedIcon data-test="no-logo-img" fontSize="medium" />
      </Box>
    );
  }

  return (
    <Box sx={commonContainerStyles}>
      <img
        src={`/publisher-marketplace-logos/${name}`}
        alt={`${name} logo`}
        onError={() => setIsError(true)}
        style={{
          display: 'block',
          maxWidth: '100%',
          minHeight: height,
          width: 'auto',
        }}
      />
    </Box>
  );
};
